import PreviewPDF from './preview-pdf.vue'
import Reason from './reason_delete.vue'
import academicV2 from './academic-v2.vue'
import studentListV2 from './student-list-v2.vue'
import feeItemDetailV2 from './fee-item-detail-v2.vue'

export { PreviewPDF, Reason, academicV2, studentListV2, feeItemDetailV2 }
